import { render, staticRenderFns } from "./SpecimenClinic.vue?vue&type=template&id=205f8c02"
import script from "./SpecimenClinic.vue?vue&type=script&lang=js"
export * from "./SpecimenClinic.vue?vue&type=script&lang=js"
import style0 from "./SpecimenClinic.vue?vue&type=style&index=0&id=205f8c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports